module.exports = __webpack_public_path__ + "static/media/marcoAmarillo.450120b1.svg";